import { Box, Skeleton } from '@redbubble/design-system';
import styles from './Bubble.module.scss';

export const BubbleLoading: React.FC = () => {
  return (
    <Box className={styles.skeletonPill}>
      <Skeleton
        animated
        width={130}
        height={34}
        data-testid="bubble-skeleton"
      />
    </Box>
  );
};
